import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Row, Col } from "reactstrap";
import { LinkContainer } from "react-router-bootstrap";

const StyledProperty = styled.section`
  margin-bottom: 10px;
  border: 1px solid rgba(232, 232, 232, 0.7);
  border-radius: 5px;
  overflow: hidden;

  &:hover {
    box-shadow: 0 0 2px 1px rgba(232, 232, 232, 0.9);
  }
`;

const PropertyImage = styled(Col)`
  height: 200px;
  overflow: hidden;

  img {
    width: 100%;
  }
`;

const Status = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
  width: 150px;
  height: 40px;
  font-size: 16px;
  color: #fff !important;
  text-align: center;
  z-index: 9999;
  margin-right: 16px;
  border-radius: 5px;
  ${({ status }) =>
    status === "Let Agreed" || status === "Sold STC"
      ? `
    background: red;
  `
      : status === "Under Offer"
      ? `background: orange;`
      : `background: none;`}
  ${({ status }) => status === "Available" && `display: none;`}
`;

const PropertyDescription = styled.div`
  padding: 5px 10px 0;

  h4 {
    margin: 20px auto;
    color: #999;
    font-family: Raleway;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    cursor: default;
  }

  p {
    color: #999;
    font-family: Raleway;
    font-size: 12px;
    text-transform: uppercase;
    cursor: default;
  }
`;

const Property = ({ property, propertyType, user }) => (
  <LinkContainer to={`/property/${property.id}`}>
    <Col xs={12} sm={6} md={4} lg={3}>
      <StyledProperty>
        <Row>
          <Status status={property.status_name}>{property.status_name}</Status>
          <PropertyImage xs={4} sm={12}>
            <img
              src={property.original || property.thumbnail}
              alt={property.advertise_address}
            />
          </PropertyImage>
          <Col xs={8} sm={12}>
            <PropertyDescription>
              <h4>{property.advertise_address}</h4>
              <Row>
                <Col xs={6} sm={4}>
                  <p>Beds</p>
                  <p>Type</p>
                  <p>Price</p>
                </Col>
                <Col xs={6} sm={8}>
                  <p>{property.bedrooms || 0}</p>
                  <p>{propertyType.name || " "}</p>
                  <p
                    dangerouslySetInnerHTML={{ __html: property.price_display }}
                  ></p>
                </Col>
              </Row>
            </PropertyDescription>
          </Col>
        </Row>
      </StyledProperty>
    </Col>
  </LinkContainer>
);

Property.propTypes = {
  property: PropTypes.object.isRequired,
  user: PropTypes.object,
  propertyType: PropTypes.object
};

Property.defaultProps = {
  user: {},
  propertyType: {}
};

export default Property;



// WEBPACK FOOTER //
// ./src/components/Property.js